import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-6 py-3"
}
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = {
  key: 1,
  class: ""
}
const _hoisted_4 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_5 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_7 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_8 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_9 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_10 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_11 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_12 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_13 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_14 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_15 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { key: 2 }

import AdminLayout from '@/layouts/AdminLayout.vue';
import BranchesLayout from '../components/BranchesLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import StatusPill from '@/components/StatusPill.vue';
import PagePagination from '@/components/PagePagination.vue'
import DatePicker from '@/components/inputs/DatePicker.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';

import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import LoadingModal from '@/components/modal/LoadingModal.vue';

import ActivityLogsTable from '@/components/ActivityLogsTable.vue';

import { useRouter, useRoute } from 'vue-router';
import { onMounted, ref, computed, watch } from 'vue';
import branchBooking from "@/classes/BranchBooking";
import BookingService from '@/classes/BookingService';
import { paginatePage } from '@/helpers/PageHelper';
import throttle from "lodash/throttle";
import { useNetworkStore } from '@/store/network';
import AuthService from "@/classes/AuthService";
import { PatientType } from '@/enums/PatientType';

import { formateTimeSlot } from "@/helpers/TimeFormatter"

import { formatter } from '@/helpers/NumberHelper'


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();

// Data
const loader      = ref(false);
const showSuccess = ref(false);
const showError   = ref(false);
const errorMsg    = ref(null);
const branchId    = ref(route.params.id)
const status    = ref(route.query.status)

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

// Query
const searchText = ref();
const filterDate = ref(null);
const filterCreatedDate = ref(null);
const goToPage   = ref();

const patientType = ref(null);
const bookingType = ref(null);
const statusType = ref(null);

const applyFilters = () => {
    indexBranchBooking(goToPage.value);
}

const searchData = (val: string) => {
    searchText.value = val
}

// Page Renderer Data
const items = ref([]);
const items_count = ref(0);

// Logs
const log_counts      = ref(null);
const logs            = ref(null);
const log_event_lists = ref(null);

const getPatientType = (type: number) => {
    switch (type) {
        case PatientType.ALL:
        return 'All';
        case PatientType.SPECIFIC:
        return 'Specific';
        default:
        return 'Unknown';
    }
}

// Methods
const indexBranchBooking = (data: string) => {
    loader.value = true;

    // console.log(isNetworkAvailable.value)

    if(isNetworkAvailable.value) {
        console.log("Online - Fetching Bookings...")

        const branchId         = route.params.id ? `&branchId=${route.params.id}` : '';
        const goToPageValue    = paginatePage(data);
        const queryString      = searchText.value ? `&query=${searchText.value}` : '&query';
        const dateQuery        = filterDate.value ? `&filterDate=${filterDate.value}` : '';
        const dateCreatedQuery = filterCreatedDate.value ? `&filterCreatedDate=${filterCreatedDate.value}` : '';
        const statusTypeQuery  = route.query.status ? `&status=${route.query.status}` : '';
        const bookingTypeQuery = bookingType.value ? `&bookingType=${bookingType.value}` : '';
        const patientTypeQuery = patientType.value ? `&patientType=${patientType.value}` : '';
        const requestedAtQuery = `&requested_at=${new Date().toISOString()}`;
        
        branchBooking.indexBranchBooking(`${branchId}&${goToPageValue}${queryString}${dateQuery}${dateCreatedQuery}${statusTypeQuery}${bookingTypeQuery}${patientTypeQuery}${requestedAtQuery}`)
            .then((response: any) => {
                loader.value = false;
                items.value = response.data;
                items_count.value = response.data.total;

                log_counts.value      = response?.data.log_counts
                logs.value            = response?.data.logs
                log_event_lists.value = response?.data.log_event_lists

            })
            .catch((err) => {
                loader.value = false;
                showError.value = true;
                errorMsg.value = err.response.data.message;
                
                if(err.response.status == 401) {
                    window.location.replace('/login');
                }

                if(err.response.status == 403) {
                    errorMsg.value = "You don't permission to view to page";
                }
            })
    } else {
        console.log("Offline - Fetching Bookings...")

        const goToPageValue   = paginatePage(data);
        const currentDate = new Date();
        const date = new Date(currentDate);
        date.setDate(currentDate.getDate() + 30);

        const dateQuery = `filterDate=${currentDate.toISOString().split("T")[0]},${date.toISOString().split("T")[0]}`;
        const branchId  = route.params.id ? `branchId=${route.params.id}` : '';
        
        branchBooking.indexBranchBooking(`${branchId}&${dateQuery}&${goToPageValue}&offline=true`)
            .then((response: any) => {
                loader.value = false;
                items.value = response.data;
                items_count.value = response.data.total;

            })
            .catch(() => {
                loader.value = false;
                showError.value = true;
                errorMsg.value = "Oppps... No available data was saved for offline use.";
            })
    }
        
}

const preCacheSelectedBooking = async (booking: any) => {
    try {
        // Precache Selected Booking
        if(booking.patient_type == 'Individual' || booking.patient_type == 'Dependent') {
            await BookingService.fetchIndividualBooking(booking.booking_id)
        } else {
            await BookingService.fetchCorporateBooking(booking.corporate_booking_id)
        }
    } catch(error: any){
        console.log(error.response.status)
    }
}

const preCacheSelectedBookingScheduleLogs = async (booking: any) => {
    try {
        // Precache Selected Booking Schedule Logs
        if(booking.patient_type == 'Individual' || booking.patient_type == 'Dependent') {
            await BookingService.fetchScheduleLogs(booking.booking_type, booking.booking_id)
        } else {
            await BookingService.fetchScheduleLogs(booking.booking_type, booking.corporate_booking_id)
        }
    } catch(error: any){
        console.log(error.response.status)
    }
}

const preCacheLoader = ref(false);
const isLastBookingIndexCached = ref(false);
const isLastSelectedBookingCached = ref(false);

const preCacheBookings = async () => {
    const currentDate = new Date();
    const date = new Date(currentDate);
    date.setDate(currentDate.getDate() + 30);
    
    const dateQuery       = `filterDate=${currentDate.toISOString().split("T")[0]},${date.toISOString().split("T")[0]}`;
    const branchId        = `branchId=${route.params.id}`;
    
    const cache = await caches.open('shinagawa-admin');
    const cachedResponse = await cache.match(`${process.env.VUE_APP_API_URL}branch-bookings/index?${AuthService.getHybrainTokenQueryString()}&${branchId}&${dateQuery}&offline=true`);

    if(!cachedResponse) {
        preCacheLoader.value = true;
        try {
            // Precache Bookings
            const response = await branchBooking.indexBranchBooking(`${branchId}&${dateQuery}&offline=true`)
            const total = response.data.total;
            const pages = Math.ceil(total / 10);
    
            for (let index = 0; index < pages; index++) {
                const page = index + 1;
                const res = await branchBooking.indexBranchBooking(`${branchId}&${dateQuery}&page=${page}&offline=true`)
    
                if(typeof res.data.data == 'object') {
                    let booking = null;
                    for (let i = 0; i < Object.values(res.data.data).length; i++) { 
                        booking = Object.values(res.data.data)[i];
                        preCacheSelectedBooking(booking);
                        preCacheSelectedBookingScheduleLogs(booking);
                        if (i === Object.values(res.data.data).length - 1) {
                            isLastSelectedBookingCached.value = true;
                            console.log("Last iteration for selected booking");
                        }
                    }
                } else {
                    let booking = null;
                    for (let i = 0; i < res.data.data.length; i++) {
                        booking = res.data.data[i];
                        preCacheSelectedBooking(booking);
                        preCacheSelectedBookingScheduleLogs(booking);

                        if (i === res.data.data.length - 1) {
                            isLastSelectedBookingCached.value = true;
                            console.log("Last iteration for selected patient");
                        }
                    }
                }

                if (index === pages - 1) {
                    isLastBookingIndexCached.value = true;
                    console.log("Last iteration for bookings index");
                }
            }

        } catch(error: any){
            console.log(error.response.status)
        }
        // preCacheLoader.value = false;
    } else {
        isLastBookingIndexCached.value = true;
        isLastSelectedBookingCached.value = true;
    }
}

// Tabs
const tabs: { name: string, count: number, allowed: boolean }[] = computed(() => [
    {
        name: 'All',
        count: !status.value ? items_count.value : 0,
        href: `/branches/${route.params.id}/bookings`,
        allowed: true
    },
    {
        name: 'Soft',
        count: status.value == 'Soft' ? items_count.value : 0,
        href: `/branches/${route.params.id}/bookings?status=Soft`,
        allowed: isNetworkAvailable.value
    },
    {
        name: 'Booked',
        count: status.value == 'Booked' ? items_count.value : 0,
        href: `/branches/${route.params.id}/bookings?status=Booked`,
        allowed: isNetworkAvailable.value
    },
    {
        name: 'Done',
        count: status.value == 'Done' ? items_count.value : 0,
        href: `/branches/${route.params.id}/bookings?status=Done`,
        allowed: isNetworkAvailable.value
    },
    {
        name: 'No Show/Cancelled',
        count: status.value == 'Cancelled/No-Show' ? items_count.value : 0,
        href: `/branches/${route.params.id}/bookings?status=Cancelled/No-Show`,
        allowed: isNetworkAvailable.value
    },
    // TODO : Uncomment when logs are available
    // {
    //     name: 'Activity logs',
    //     count: log_counts.value,
    //     href: `/branches/${route.params.id}/bookings/logs`,
    //     allowed: true
    // }
]);

// Headers
const headers: { text: string }[] = [
    { text: 'ID' },
    { text: 'Patient' },
    { text: 'Patient Type' },
    { text: 'Booking Type' },
    { text: 'Branch' },
    { text: 'Company' },
    { text: 'Package' },
    // { text: 'Rider' },
    { text: 'Timeslot' },
    { text: 'Total Fee' },
    { text: 'Status' },
    { text: 'Booking Date' },
    { text: 'Created Date' },
];

const bookingTypes = [
    { id: '1', label: 'All', value: 'All' },
    { id: '2', label: 'New', value: 'New' },
    { id: '3', label: 'Rescheduled', value: 'Rescheduled' },
];

const patientTypes = [
    { id: '1', label: 'All', value: 'All' },
    { id: '2', label: 'Individual', value: 'Individual' },
    { id: '3', label: 'Corporate', value: 'Corporate' },
    { id: '4', label: 'Dependent', value: 'Dependent' },
];

const statusTypes = [
    { id: '1', label: 'All', value: 'All' },
    { id: '2', label: 'Booked', value: 'Booked' },
    { id: '3', label: 'Cancelled/No-Show', value: 'Cancelled/No-Show' },
    { id: '4', label: 'Done', value: 'Done' },
];

/**
 * ********************************
 * Export Company 
 * ********************************
 */
 const exportData = async () => {
    try {
        loader.value = true;
        const dateQuery   = filterDate.value ? `&filterDate=${filterDate.value}` : '';
        const params      = `branchId=${branchId.value}&tab=all`;

        await BookingService.exportBooking(`${params}&${dateQuery}`);

        showSuccess.value = true;
    } catch (error) {
        showError.value = true;
        errorMsg.value  = error.response?.data.message;
    } finally {
        loader.value = false;
    }
};

const getStatusColor = (status: string) => {
    if(status) {
        let color = null;
        switch (status) {
            case 'Booked':
                color = 'blue';
                break;
        
            case 'Cancelled/No-Show':
            case 'Cancelled':
                color = 'red';
                break;
        
            case 'Done':
                color = 'green';
                break;
            
            default:
                color = 'yellow'
                break;
        }

        return color;
    }

    return 'yellow';
}

const loadingInterval = () => {
    const checker = setInterval(() => {
        if(isLastBookingIndexCached.value && isLastSelectedBookingCached.value) {
            console.log("All resources has ben cached")
            setTimeout(() => {
                preCacheLoader.value = false;
            }, 3000);
            clearInterval(checker);
        } else {
            console.log("Caching... plase wait")
        }
    }, 1000)
}

const downloadResources = async () => {
    isLastBookingIndexCached.value = false;
    isLastSelectedBookingCached.value  = false;
    caches.delete('shinagawa-admin');

    // setTimeout(() => {
        preCacheBookings();
        loadingInterval();
    // }, 1000);
}

watch(
    searchText,
    throttle(() => {
        indexBranchBooking(goToPage.value)
    }, 1000)
);

watch(
    () => isNetworkAvailable.value,
    (val) => {
        console.log('Watcher - Network: ' + val);
        indexBranchBooking(goToPage.value);
    }
);

onMounted( () => {
    loader.value = true;
    setTimeout(() => {
        console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
        indexBranchBooking(goToPage.value);
        // preCacheBookings(); // Uncomment to pre-cache bookings on mount
    }, 1000);
    
    // Set Internal for Resources Downloader
    // loadingInterval(); // Uncomment to start loading interval on mount
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Bookings",
    "show-back": "",
    backUrl: `/branches`
  }, {
    default: _withCtx(() => [
      _createVNode(BranchesLayout, { "branch-id": branchId.value }, {
        contents: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(TabComponent, {
              tabs: tabs.value,
              "button-items": true
            }, _createSlots({ _: 2 }, [
              (isNetworkAvailable.value)
                ? {
                    name: "buttons",
                    fn: _withCtx(() => [
                      _createVNode(ButtonComponent, {
                        class: "text-gray-900",
                        secondary: "",
                        exportBtn: "",
                        onClick: exportData,
                        disabled: loader.value
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode(" Export ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"]),
                      (_ctx.$hasPermission('soft-book-dates-for-individual-patient'))
                        ? (_openBlock(), _createBlock(ButtonComponent, {
                            key: 0,
                            createBtn: "",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(`/branches/${branchId.value}/bookings/create`)))
                          }, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                              _createTextVNode(" Create ", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["tabs"])
          ]),
          (isNetworkAvailable.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(FilterComponent, {
                  search: searchText.value,
                  onFetchData: searchData,
                  "onUpdate:filters": applyFilters,
                  textFilters: false
                }, {
                  fields: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(DatePicker, {
                        id: "filterCreatedDate",
                        name: "filterCreatedDate",
                        range: "",
                        is24: "",
                        isPresetRanges: "",
                        modelValue: filterCreatedDate.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterCreatedDate).value = $event)),
                        placeholder: "Created Start and End Date",
                        label: "Created Start and End Date"
                      }, null, 8, ["modelValue"]),
                      _createVNode(DatePicker, {
                        id: "filterDate",
                        name: "filterDate",
                        range: "",
                        is24: "",
                        isPresetRanges: "",
                        modelValue: filterDate.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterDate).value = $event)),
                        placeholder: "Booking Start and End Date",
                        label: "Booking Start and End Date"
                      }, null, 8, ["modelValue"]),
                      _createVNode(MultiselectInput, {
                        modelValue: patientType.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((patientType).value = $event)),
                        id: "patientType",
                        name: "patientType",
                        label: "Patient Type",
                        placeholder: "Patient Type",
                        options: patientTypes
                      }, null, 8, ["modelValue"]),
                      _createVNode(MultiselectInput, {
                        modelValue: bookingType.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((bookingType).value = $event)),
                        id: "bookingType",
                        name: "bookingType",
                        label: "Booking Type",
                        placeholder: "Booking Type",
                        options: bookingTypes
                      }, null, 8, ["modelValue"]),
                      _createVNode(MultiselectInput, {
                        modelValue: statusType.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((statusType).value = $event)),
                        id: "statusType",
                        name: "statusType",
                        label: "Status Type",
                        placeholder: "Status Type",
                        options: statusTypes
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["search"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentRoutePath !== '/bookings/logs')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(DataTable, {
                  headers: headers,
                  count: items_count.value
                }, {
                  body: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.data, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_4, _toDisplayString(item.booking_type != 'Soft' ? item.booking_id : item.id), 1),
                        _createElementVNode("td", _hoisted_5, _toDisplayString(item.patient?.first_name) + " " + _toDisplayString(item.patient?.last_name), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(item.patient_type), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(item.booking_type), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(item.branch_name), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(item.corporate_name || '--'), 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(item.package_name), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formateTimeSlot)(item.booking_start_time, item.booking_end_time)), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(formatter).format(item.total_fee)), 1),
                        _createElementVNode("td", _hoisted_13, [
                          _createVNode(StatusPill, {
                            color: getStatusColor(item.status),
                            text: item.status
                          }, null, 8, ["color", "text"])
                        ]),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(new Date(item.booking_date).toISOString().split('T')[0]), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(new Date(item.booking_created_date ? item.booking_created_date : item.created_at).toISOString().split('T')[0]), 1),
                        _createElementVNode("td", _hoisted_16, [
                          (
                                        _ctx.$hasPermission('set-individual-patient-appointment-time') ||
                                        _ctx.$hasPermission('update-individual-patient-appointment-time') ||
                                        _ctx.$hasPermission('soft-book-dates-for-individual-patient') ||
                                        _ctx.$hasPermission('update-corporate-patient') ||
                                        _ctx.$hasPermission('update-participating-employees'))
                            ? (_openBlock(), _createBlock(ActionButton, {
                                key: 0,
                                "edit-btn": "",
                                onClick: ($event: any) => (_unref(router).push(`/branches/${branchId.value}/bookings/edit/${item.patient_type == 'Individual' || item.patient_type == 'Dependent' ? item.booking_id : item.patient_type == 'Corporate' ? item.corporate_booking_id : item.id}?patient_type=${ item.patient_type == 'Individual' || item.patient_type == 'Soft' || item.patient_type == 'Dependent' ? item.patient_type : 'Corporate' }`))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["count"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(ActivityLogsTable, {
                  logs: logs.value,
                  onFetchIndex: indexBranchBooking
                }, null, 8, ["logs"])
              ])),
          _createVNode(PagePagination, {
            class: "mb-6",
            items: items.value,
            onNextPage: indexBranchBooking
          }, null, 8, ["items"])
        ]),
        _: 1
      }, 8, ["branch-id"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[8] || (_cache[8] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[9] || (_cache[9] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Bookings Export",
        content: "Export is being processed. Please check your registered email."
      }, null, 8, ["show"]),
      _createVNode(LoadingModal, {
        show: preCacheLoader.value && isNetworkAvailable.value,
        onCancel: _cache[10] || (_cache[10] = ($event: any) => (preCacheLoader.value = false)),
        onConfirm: _cache[11] || (_cache[11] = ($event: any) => (preCacheLoader.value = false)),
        restartLoader: preCacheLoader.value,
        title: "Downloading Resources",
        content: "Resources is being download for offline use. Please wait."
      }, null, 8, ["show", "restartLoader"])
    ]),
    _: 1
  }))
}
}

})